export default __webpack_public_path__ + "static/media/riqas.5e1c90f7.png";